// react-markdown uses Object.hasOwn, which is not available in older supported
// browsers such as Chrome 79. Load this before app modules that import it.
export const installObjectHasOwnPolyfill = () => {
  if (typeof Object.hasOwn !== "function") {
    Object.hasOwn = function hasOwn(object, propertyKey) {
      if (object === null || object === undefined) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), propertyKey);
    };
  }
};

installObjectHasOwnPolyfill();
